import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'emailMask',
  standalone: true,
})
export class EmailMaskPipe implements PipeTransform {
  transform(email: string): string {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      return email;
    }
    const [localPart, domain] = email.split('@');
    if (localPart.length === 1) {
      return email;
    }

    const maskedLocal = localPart.charAt(0) + '****' + localPart.charAt(localPart.length - 1);
    return `${maskedLocal}@${domain}`;
  }
}
